import { IgTypography } from "@intelligems/ig-theme";
import type { ComponentPlacementLocation } from "@intelligems/ig-types";
import Stack from "@mui/material/Stack";
import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { PLACEMENT_LOCATION_LABELS } from "./options";

export const DormantAnchorPlacementSection = ({
  location,
  anchorKey,
}: {
  location: ComponentPlacementLocation;
  anchorKey: string;
}) => (
  <Stack spacing={2}>
    <Panel.Header>Placement</Panel.Header>
    <Stack spacing={1}>
      <Panel.Label>Location</Panel.Label>
      <IgTypography>{PLACEMENT_LOCATION_LABELS[location]}</IgTypography>
    </Stack>
    <Stack spacing={1}>
      <Panel.Label>Anchor key</Panel.Label>
      <IgTypography>{anchorKey}</IgTypography>
    </Stack>
    <IgTypography variant="body2" color="text.secondary">
      This theme-block placement stays active with legacy rules. Re-enable
      Agentic Logic to change it.
    </IgTypography>
  </Stack>
);
